export function modifyInputValue(value, socialType, socialName) {
  if (socialType === 'url') {
    if (
      !value.startsWith('http://') &&
      !value.startsWith('https://')
    ) {
      return `https://${value}`;
    }
  }

  if (
    ['tiktok', 'clubhouse'].includes(socialName.toLowerCase())
  ) {
    if (value.startsWith('@')) {
      return value;
    } else {
      return `@${value}`;
    }
  }

  if (
    ['instagram', 'telegram', 'snapchat'].includes(socialName.toLowerCase()) &&
    value.startsWith('@')
  ) {
    return value.replace(value[0], '');
  }

  return value;
}
